module.exports = __webpack_public_path__ + "static/media/cherry-no-comments.2aa321b0.png";